import { render } from "./indexSituationComponent.vue?vue&type=template&id=522b4f47"
import script from "./indexSituationComponent.vue?vue&type=script&lang=js"
export * from "./indexSituationComponent.vue?vue&type=script&lang=js"

import "./indexSituationComponent.vue?vue&type=style&index=0&id=522b4f47&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__